import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CallHistorySearchParams, Pager } from './call-history-params.interface';
import { GetCallHistoryAction } from './call-history.actions';
import { Store } from '@ngrx/store';
import { IState } from '../shared/models/state';

@Injectable({
  providedIn: 'root'
})
export class CallHistoryService {
  // required for users form control, but backend expects null
  public static UNASSIGNED_USER_ID = -1;
  constructor(private http: HttpClient, private store: Store<IState>) {}

  getCallHistory(payload: CallHistorySearchParams) {
    return this.http.post<any[]>('/calls/history/paginated', {
      ...payload,
      pager: payload.pager
        ? {
            ...payload.pager,
            page: payload.pager.pageIndex + 1,
            limit: payload.pager.pageSize
          }
        : {}
    });
  }

  addFilter(type: string, value: any, pager: Pager) {
    this.store.dispatch(new GetCallHistoryAction({ [type]: value, pager: pager }));
  }

  getPagerIndexReset(pager) {
    return pager ? { ...pager, pageIndex: 0 } : null;
  }

  setCheckboxAll(itemsList, requestedProjectList) {
    if (!requestedProjectList.length) {
      return {
        allSelected: false,
        indeterminate: false
      };
    } else if (requestedProjectList.length === itemsList.length) {
      return {
        allSelected: true,
        indeterminate: false
      };
    } else if (!!requestedProjectList.length && !itemsList.length) {
      return {
        allSelected: false,
        indeterminate: false
      };
    } else {
      return {
        allSelected: true,
        indeterminate: true
      };
    }
  }
}
